import i18n from "@/lang/i18n"

export const HEADER = [
  i18n.global.t('pages.gpsTrackerSetting.list.id'),
  i18n.global.t('pages.gpsTrackerSetting.list.operationOfficeName'),
  i18n.global.t('pages.gpsTrackerSetting.list.tripStartTime'),
  i18n.global.t('pages.gpsTrackerSetting.list.commonDriverName'),
  i18n.global.t('pages.gpsTrackerSetting.list.edit'),
  i18n.global.t('pages.gpsTrackerSetting.list.updatedAt'),
  i18n.global.t('pages.gpsTrackerSetting.list.delete'),
]
